import { useSelector } from "react-redux";
import { getNodeStructure } from "../redux/slice/structureSlice";

function useNode(id) {
  const element = useSelector(getNodeStructure(id));
  
  return element;
}

export default useNode;